import React, { useEffect, useState } from "react";
import { Getdata } from "../../helpers/api.service";
import { useNavigate } from "react-router-dom";
import { ChevronDown, ChevronRight } from "lucide-react";

const AdmissionGuidelines = () => {
  const [data, setData] = useState([]);
  let [loading, setLoading] = useState(false);
    const [open, setOpen] = useState(null);

  const fetchData = () => {
    setLoading(true);
    Getdata(
      process.env.REACT_APP_URL +
        `/front/admission-details/admission-guidelines-list/${process.env.REACT_APP_SUBDOMAIN}`
    )
      .then((res) => {
        console.log("News API response:", res);
        if (res?.data) {
          setData(res.data);
        }
        // setImages(res.data.map((item) => item.image));
        setLoading(false);
      })
      .catch((err) => {
        console.error("Error fetching news:", err);
        setLoading(false);
      });
  };

  useEffect(() => {
    fetchData();
  }, []);

   const toggleAccordion = (index) => {
    setOpen(open === index ? null : index);
  };

  return (
    <>
    <div className="max-w-full sm:max-w-screen-lg mx-auto mb-5 px-4 sm:px-8">
        <div className="">
          {data.map((item, index) => (
              <div key={index}>
                  <button
                      className={`w-full text-left py-3 px-4 mb-4 flex justify-between bg-[#F9F5FF] ${open === index ? 'bg-[#F9F5FF] border-b-2  rounded-t-md' : 'border-1 rounded-md'}`}
                      onClick={() => toggleAccordion(index)}
                  >
                      <p className="text-black text-[15px] sm:text-base">{item.title}</p>
                      <span>
                          {open === index ? (
                              <ChevronDown size={20} />
                          ) : (
                              <ChevronRight size={20} />
                          )}
                      </span>
                  </button>

                  <div
                      className={`transition-all duration-500 ease-in-out overflow-hidden  mb-4 -mt-4 ${
                          open === index ? 'max-h-[1000px] opacity-100' : 'max-h-0 opacity-0'
                      }`}
                  >
                      {open === index && (
                          <div className="bg-[#F9F5FF] p-4 rounded-b-md flex items-start">
                              <p className="text-sm sm:text-base text-left">{item.description}</p>
                          </div>
                      )}
                  </div>
              </div>
          ))}
        </div>
    </div>


      {data.length === 0 && (
        <div className="h-[50vh] flex items-center justify-center w-full">
          <h1 className="text-center text-gray-400">No Data Found</h1>
        </div>
      )}
    </>
  );
};

export default AdmissionGuidelines;
